<style lang="scss">
    .licenses-panel {
        cursor: pointer;
        position: relative;
        background-clip: padding-box;
        .license-row {
            position: relative;
            &__top {
                padding-top: 1.9rem;
                border-bottom: 1px solid;
                margin-bottom: 12px;
            }
            /*height: 100%;*/
            .license_img{
                width: 40px;
            }
            .license-name {
                font-size: 1rem;
                font-weight: 600;
                text-transform: uppercase;
                text-align: center;
                margin-top: 0px;
                margin-bottom: 0px;
                padding: 15px 10px;
                color: #fff;
            }
            .price{
                font-family: Poppins;
                font-size: 25px;
                font-weight: 600;
                text-align: center !important;
                margin-bottom: 10px;
                color: #fff;
            }

            .divider{
                width: 90%;
                border-bottom: 1px solid;
                margin: 0 5%;
            }
            .file-type-wrapper {
                display: flex;
                justify-content: space-around;
                padding: 10px 5px 5px 5px;
                margin: 0 5px;
                .fa-check {
                    color: #27c24c;
                    font-weight: bold;
                }
            }
            .separator-wrapper {
                text-align: center;
                line-height: 18px;
                .separator {
                    display: inline-block;
                    border-top: 1px solid;
                    width: 50%;
                }
            }
            .license-drawer-toggle-wrapper {
                text-align: center;
                padding: 10px;
                .license-drawer-toggle {
                    cursor: pointer;
                    i {
                        font-size: 16px;
                        margin-left: 5px;
                    }
                }
            }
            .license-drawer {
                max-height: 0px;
                overflow: hidden;
                transition: max-height 0.3s;
                .license-terms-table {
                    /*margin: 0 0 45px 0 !important;*/
                }
            }
            .license-drawer.open {
                max-height: 650px;
            }

            .withDiscount{
                /*margin: 0 0 35px 0 !important;*/
            }

        }

        .license-discounts {
            text-align: center;
            padding: 15px;
            justify-content: center;
            border-top-width: 1px;
            border-top-style: solid;
            font-size: 14px;
            font-weight: 500;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            cursor: pointer;
            z-index: 56;
        }
        .license-footer{
            position: absolute;
            bottom: -1px;
            left: -1px;
            right: -1px;
            height: 60px;
            background-size: cover;
            z-index: 55;
        }

        &.highlighted {
            .license-discounts {
                left: 0;
                right: 0;
                bottom: 0;
            }
            &:hover {
                .license-discounts {
                    border: 1px solid;
                    border-top: none;
                    padding-bottom: 9px;
                }
            }
        }

        @media screen and (max-width: 900px) {

        }

        @media screen and (max-width: 768px) {
            .license-row{
                .license-discounts {
                    bottom: 0px !important;
                    width: 100% !important;
                    margin-left: 0px;
                }
            }
        }

        @media screen and (max-width: 500px) {
            .license-row{
                .license-discounts {
                    bottom: 0px !important;
                    width: 100% !important;
                    margin-left: 0px;
                }
            }
        }
    }
</style>

<template>
    <div class="licenses-panel" @mouseover="hover(true)" @mouseleave="hover(false)" :style="$licenseRowStyle">
        <div class="license-row">
            <div class="license-row__top" :style="$transparentBorderColorStyle">
                <license-icon class="license_img" :size="img" :highlighted-license="current"></license-icon>
                <h3 class="license-name" :style="[!current ? $highlightColor : '']">{{license.name}}</h3>
            </div>
            <!--            <div class="divider" :style="$transparentBorderColorStyle"></div>-->

            <p v-if="license.price > 0" class="price" :style="[!current ? $highlightColor : '']">
                <span>{{license.price | displayPrice}}</span>
            </p>

            <template v-if="toggleLicenseTerms">
                <div class="file-type-wrapper">
                    <span><i class="fa fa-check"></i> MP3</span>
                    <span v-if="license.wav"><i class="fa fa-check"></i> WAV</span>
                    <span v-if="license.trackout"><i class="fa fa-check"></i> Trackout</span>
                </div>
                <div class="separator-wrapper"><div class="separator border-mid-grey"></div></div>
            </template>

            <div class="license-drawer-toggle-wrapper" v-if="toggleLicenseTerms">
                <span class="license-drawer-toggle" @click="toggleDrawer">License Terms <i class="text-purple fa" :class="{'fa-chevron-down': !showDrawer, 'fa-chevron-up': showDrawer}"></i></span>
            </div>
            <div class="license-drawer" :class="{'open': showDrawer || !toggleLicenseTerms , 'withDiscount' :showDiscounts}">
                <license-terms-table :current="current" :license="license" :user="user" :contractModal="true" class="license-terms-table"></license-terms-table>
            </div>
        </div>
        <div v-if="license.discountsAvailable() && showDiscounts" class="license-discounts c-button c-button--for-license-row" data-toggle="modal" data-target="#discountsModal" :style="$licenseDiscountsButtonStyle(!current)">
            <span class="c-button__left-icon">
                <base-discount-icon :fill="$licenseDiscountsButtonStyle(!current).color"></base-discount-icon>
            </span>
            Package Discounts
        </div>
    </div>
</template>

<script>
    import LicenseTermsTable from './licensetermstable.vue'
    import LicenseIcon from './licenses/licenseicon.vue'
    import BaseDiscountIcon from '../components/base/icons/base-discount-icon.vue'
    import Configure from './../mixins/configure'

    export default {
        props: {
            license: Object,
            user: Object,
            toggleLicenseTerms: {
                type: Boolean,
                default: true
            },
            showDiscounts: {
                type: Boolean,
                default: false
            },
            img : '',
            current : false
        },
        created() {
            if (this.config.license && this.config.license == this.license.id)   {
                this.$data.$highlightedLicense = true
            }
        },
        data() {
            return {
                showDrawer: false
            }
        },
        computed: {
            config() {
                return this.$store.state.currentConfig
            },
            $licenseCurrentFooterStyle(){
                return {
                    'background-image': 'url('+ this.assetsPath('current') +')'
                }
            },
            $licenseFooterStyle(){
                return {
                    'background-image': 'url('+ this.assetsPath('footer') +')'
                }
            }
//            highlightedLicense() {
//                if (this.config.license && this.config.license == this.license.id) {
//                    return true
//                }
//                return false
//            }
        },
        components: {
            LicenseTermsTable, LicenseIcon, BaseDiscountIcon
        },
        mixins: [Configure],
        methods: {
            toggleDrawer() {
                this.showDrawer = !this.showDrawer
            },
            hover(isHovering) {
                this.$data.$hover.licenseRow = isHovering
            },
            assetsPath(imageName) {
                return `${ab.baseUrl}/img/webstore/${imageName}.png`
            }
        }
    }
</script>
